@use "@fukuri-admins/ui/layout" as *;

.headRow {
  white-space: nowrap;
}

.creditStatusCol {
  width: 100px;
}

.creditStatusGranted {
  color: text('Low');
}

.creditStatusButton {
  @include typography('Jp/14_W3');

  color: text('Sky');
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;

  &:hover {
    text-decoration: underline;
  }
}

.creditIncompleteRow {
  background-color: background('Yellow');
}

.companyNameCol {
  min-width: 120px;
}

.groupCol {
  width: 150.4px;
}

.partnerBranchCol {
  width: 150.4px;
}

.contactPersonCol {
  min-width: 100px;
}

.contractPlanCol {
  width: 200px;
}

.createdAtCol {
  width: 136px;
}

.updatedAtCol {
  width: 136px;
}

.actionCol {
  width: 88px;
  text-align: right;
}

.deleteItem {
  color: text('Red');
}
